import { getObject, getText } from "../ChoiceApi";
import { BootstrapPaddingValue } from "../StyleHelpers";

export const TestingService = {
    CacheAllUsersTest,
    GetCacheBustTypes,
    ExecuteWindowBuild,
    CacheTestVerifyAllDatabases
}

export async function CacheAllUsersTest(): Promise<string | undefined>
{
    return await getObject<string>('api/Testing/CacheAllUsersTest'); 
}

export async function GetCacheBustTypes(): Promise<string[] | undefined>
{
    return await getObject<string[]>('api/Testing/GetCacheBustTypes'); 
}

export async function ExecuteWindowBuild(menu:string | number, executeCount:number): Promise<string | undefined>
{
    return await getObject<string>(`api/Testing/ExecuteWindowBuild/${menu}/${executeCount}`); 
}

export async function CacheTestVerifyAllDatabases(): Promise<string | undefined>
{
    return await getText('api/Testing/CacheTestVerifyAllDatabases'); 
}



